import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  SOFT_GREY_COLOR,
  WHITE_COLOR,
} from 'containers/App/constants';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const FeedbackLauncherButton = styled.button`
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 1040;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${LG_COLOR};
  color: ${WHITE_COLOR};
  box-shadow:
    0 10px 24px rgb(15 23 42 / 18%),
    0 2px 8px rgb(15 23 42 / 12%);
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;

  &:hover,
  &:focus {
    background: #8f022f;
    transform: translateY(-1px);
    box-shadow:
      0 14px 28px rgb(15 23 42 / 20%),
      0 4px 10px rgb(15 23 42 / 14%);
  }

  &:focus-visible {
    outline: 3px solid rgb(165 1 53 / 20%);
    outline-offset: 3px;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 768px) {
    left: 12px;
    bottom: 12px;
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
`;

export const UserFeedbackModalStyles = styled(Modal)`
  .modal-dialog {
    width: min(840px, calc(100vw - 32px));
    max-width: none;
    margin: 20px auto;
  }

  .modal-content {
    height: min(720px, calc(100vh - 40px));
    border: 0;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow:
      0 0 0 1px rgb(15 23 42 / 8%),
      0 28px 70px rgb(15 23 42 / 22%);
  }

  .modal-dialog.feedback-dialog--browser .modal-content {
    height: min(660px, calc(100vh - 40px));
  }

  .modal-header {
    padding: 16px 18px;
    border-bottom: 1px solid rgb(15 23 42 / 8%);
    background:
      radial-gradient(circle at top left, rgb(165 1 53 / 9%), transparent 34%),
      ${WHITE_COLOR};
  }

  .modal-title {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: ${GRAPHITE_COLOR};
    font-size: 1.05rem;
    font-weight: 800;
    line-height: 1.2;
  }

  .modal-title small {
    display: block;
    margin-top: 2px;
    color: #667085;
    font-size: 0.76rem;
    font-weight: 600;
  }

  .feedback-title-mark {
    width: 34px;
    height: 34px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    background: ${LG_COLOR};
    color: ${WHITE_COLOR};
    box-shadow: 0 10px 22px rgb(165 1 53 / 20%);
  }

  .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 18px 18px;
    background:
      linear-gradient(180deg, #fbfcff 0%, ${WHITE_COLOR} 42%),
      ${WHITE_COLOR};
  }

  .feedback-modal-tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
    margin-bottom: 14px;
    padding: 4px;
    border-radius: 14px;
    background: ${ICE_COLOR};
  }

  .feedback-modal-tabs button,
  .feedback-status-switch button {
    min-height: 34px;
    border: 0;
    border-radius: 11px;
    background: transparent;
    color: #667085;
    font-size: 0.88rem;
    font-weight: 700;
    transition:
      background 0.18s ease,
      box-shadow 0.18s ease,
      color 0.18s ease;
  }

  .feedback-modal-tabs button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .feedback-modal-tabs button.is-active,
  .feedback-status-switch button.is-active {
    background: ${WHITE_COLOR};
    color: ${GRAPHITE_COLOR};
    box-shadow:
      0 1px 2px rgb(15 23 42 / 8%),
      0 0 0 1px rgb(15 23 42 / 8%);
  }

  .feedback-prefill-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 14px;
  }

  .feedback-field--full {
    grid-column: 1 / -1;
  }

  .feedback-label {
    margin-bottom: 5px;
    color: ${GRAPHITE_COLOR};
    font-size: 0.78rem;
    font-weight: 600;
  }

  .feedback-readonly {
    min-height: 38px;
    border-radius: 10px;
    border: 1px solid rgb(15 23 42 / 10%);
    background: ${ICE_COLOR};
    color: ${GRAPHITE_COLOR};
    font-size: 0.86rem;
  }

  .form-control {
    border-radius: 10px;
  }

  textarea.form-control {
    min-height: 112px;
    resize: vertical;
  }

  .feedback-helper-text {
    margin: 6px 0 0;
    color: #667085;
    font-size: 0.78rem;
  }

  .feedback-screenshot-pill {
    margin-top: 8px;
    padding: 8px 10px;
    border-radius: 10px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .feedback-screenshot-pill.is-ready {
    background: #ecfdf3;
    color: #027a48;
  }

  .feedback-browser-toolbar {
    display: grid;
    grid-template-columns: minmax(170px, 0.7fr) minmax(220px, 1fr) minmax(190px, auto);
    align-items: stretch;
    gap: 10px;
    margin-bottom: 12px;
  }

  .feedback-status-switch {
    display: inline-grid;
    grid-template-columns: repeat(2, minmax(86px, 1fr));
    gap: 5px;
    padding: 4px;
    border-radius: 12px;
    background: ${ICE_COLOR};
  }

  .feedback-status-switch button {
    height: 100%;
  }

  .feedback-search-input {
    min-height: 38px;
    border-radius: 12px;
    border-color: rgb(15 23 42 / 12%);
  }

  .feedback-jira-search-link {
    min-height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border-radius: 12px;
    border: 1px solid rgb(165 1 53 / 18%);
    background: #fff7f9;
    color: ${LG_COLOR};
    font-size: 0.82rem;
    font-weight: 800;
    text-decoration: none;
    white-space: nowrap;
  }

  .feedback-jira-search-link:hover,
  .feedback-jira-search-link:focus {
    color: #8f022f;
    text-decoration: none;
    box-shadow: 0 0 0 3px rgb(165 1 53 / 10%);
  }

  .feedback-ticket-shell {
    display: grid;
    grid-template-columns: minmax(230px, 0.72fr) minmax(0, 1.28fr);
    gap: 12px;
    height: 390px;
    min-height: 0;
  }

  .feedback-ticket-shell > section,
  .feedback-ticket-shell > aside {
    min-height: 0;
  }

  .feedback-ticket-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-height: 100%;
    overflow-y: auto;
    padding-right: 4px;
  }

  .feedback-ticket-card {
    flex: 0 0 auto;
    width: 100%;
    min-height: 106px;
    padding: 11px 12px;
    border: 1px solid rgb(15 23 42 / 8%);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    background: ${WHITE_COLOR};
    color: ${GRAPHITE_COLOR};
    text-align: left;
    box-shadow: 0 2px 8px rgb(15 23 42 / 4%);
    transition:
      border-color 0.18s ease,
      background 0.18s ease,
      box-shadow 0.18s ease;
  }

  .feedback-ticket-card:hover,
  .feedback-ticket-card:focus {
    border-color: rgb(165 1 53 / 26%);
    box-shadow: 0 8px 18px rgb(15 23 42 / 8%);
  }

  .feedback-ticket-card.is-selected {
    border-color: rgb(165 1 53 / 34%);
    background: #fff7f9;
    box-shadow:
      inset 3px 0 0 ${LG_COLOR},
      0 8px 18px rgb(15 23 42 / 7%);
  }

  .feedback-ticket-card strong {
    display: -webkit-box;
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 0.9rem;
    line-height: 1.35;
    overflow-wrap: anywhere;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .feedback-ticket-card-head,
  .feedback-thread-header,
  .feedback-comment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .feedback-ticket-updated,
  .feedback-ticket-context,
  .feedback-thread-meta {
    color: #667085;
    font-size: 0.74rem;
  }

  .feedback-ticket-updated {
    min-width: 0;
    text-align: right;
    line-height: 1.3;
  }

  .feedback-ticket-context {
    display: inline-flex;
    min-width: 0;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .feedback-ticket-card-contexts {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 4px 10px;
    flex-wrap: wrap;
    margin-top: auto;
  }

  .feedback-ticket-context.is-jira {
    color: ${LG_COLOR};
    font-weight: 700;
  }

  .feedback-thread {
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid rgb(15 23 42 / 8%);
    border-radius: 14px;
    background: #fcfdff;
  }

  .feedback-thread-header {
    padding: 13px 14px 9px;
    border-bottom: 1px solid rgb(15 23 42 / 7%);
    background: ${WHITE_COLOR};
  }

  .feedback-thread-header h3 {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.35;
  }

  .feedback-thread-badges {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 7px;
  }

  .feedback-jira-ticket-link {
    display: inline-flex;
    align-items: center;
    min-height: 22px;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${ICE_COLOR};
    color: ${LG_COLOR};
    font-size: 0.75rem;
    font-weight: 800;
    text-decoration: none;
  }

  .feedback-jira-ticket-link:hover,
  .feedback-jira-ticket-link:focus {
    color: #8f022f;
    text-decoration: none;
    box-shadow: 0 0 0 2px rgb(165 1 53 / 16%);
  }

  .feedback-thread-meta {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    padding: 8px 14px 0;
  }

  .feedback-thread-message {
    flex: 0 1 auto;
    min-height: 90px;
    max-height: 170px;
    overflow-y: auto;
    margin: 10px 14px;
    padding: 10px 12px;
    border-radius: 12px;
    background: ${WHITE_COLOR};
    color: ${GRAPHITE_COLOR};
    font-size: 0.86rem;
    line-height: 1.55;
    white-space: pre-wrap;
  }

  .feedback-thread-message p {
    margin: 6px 0 0;
  }

  .feedback-thread-section-label {
    display: block;
    color: #667085;
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .feedback-jira-cta-card {
    margin: auto 14px 14px;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid rgb(165 1 53 / 14%);
    background: #fff7f9;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
    color: ${GRAPHITE_COLOR};
    font-size: 0.86rem;
    line-height: 1.45;
  }

  .feedback-jira-cta-card strong {
    font-size: 0.94rem;
  }

  .feedback-jira-cta-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .feedback-jira-cta-card .btn {
    white-space: nowrap;
  }

  .feedback-thread-comments {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
    overflow-y: auto;
    padding: 0 14px 10px;
  }

  .feedback-thread-comment {
    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid rgb(15 23 42 / 8%);
    background: ${WHITE_COLOR};
  }

  .feedback-reply-actions {
    display: flex;
    justify-content: flex-end;
    padding: 9px 14px 12px;
    background: ${WHITE_COLOR};
    border-top: 1px solid rgb(15 23 42 / 7%);
  }

  .feedback-thread-reply {
    margin: 0;
    padding: 0 14px 0;
    background: ${WHITE_COLOR};
  }

  .feedback-thread textarea.form-control {
    min-height: 70px;
    resize: vertical;
  }

  .feedback-modal-empty-state {
    min-height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    color: #667085;
    border: 1px dashed rgb(15 23 42 / 12%);
    border-radius: 14px;
    background: #fcfdff;
    padding: 18px;
  }

  .feedback-modal-empty-state.is-compact {
    min-height: 74px;
  }

  .modal-footer {
    border-top: 1px solid rgb(15 23 42 / 8%);
    padding: 12px 18px 16px;
    background: ${WHITE_COLOR};
  }

  .feedback-comment-header {
    margin-bottom: 8px;
  }

  .feedback-comment-author {
    color: ${GRAPHITE_COLOR};
    font-size: 0.84rem;
    font-weight: 700;
  }

  .feedback-comment-time {
    color: #667085;
    font-size: 0.74rem;
  }

  .feedback-comment-message {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 0.86rem;
    line-height: 1.55;
    white-space: pre-wrap;
  }

  @media (max-width: 820px) {
    .modal-dialog,
    .modal-dialog.feedback-dialog--new,
    .modal-dialog.feedback-dialog--browser {
      width: calc(100vw - 20px);
      margin: 10px auto;
    }

    .modal-content {
      height: calc(100vh - 20px);
    }

    .modal-dialog.feedback-dialog--browser .modal-content {
      height: calc(100vh - 20px);
    }

    .feedback-browser-toolbar,
    .feedback-ticket-shell {
      grid-template-columns: 1fr;
    }

    .feedback-jira-search-link {
      white-space: normal;
    }

    .feedback-jira-cta-card {
      grid-template-columns: 1fr;
    }

    .feedback-jira-cta-card .btn {
      justify-self: start;
    }

    .feedback-ticket-list,
    .feedback-thread {
      height: auto;
      max-height: none;
    }

    .feedback-ticket-shell {
      height: auto;
    }

    .feedback-thread {
      min-height: 340px;
    }
  }

  @media (max-width: 576px) {
    .feedback-modal-tabs {
      grid-template-columns: 1fr;
    }

    .feedback-prefill-grid {
      grid-template-columns: 1fr;
    }
  }
`;

export const FeedbackManagementPageStyles = styled.div`
  min-height: 100%;
  padding: 24px;
  background: ${ICE_COLOR};

  .feedback-admin-shell {
    max-width: 1560px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .feedback-admin-header {
    background: ${WHITE_COLOR};
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    padding: 22px 24px;
  }

  .feedback-admin-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .feedback-admin-title {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
  }

  .feedback-admin-subtitle {
    margin: 8px 0 0;
    color: #66707d;
    max-width: 760px;
  }

  .feedback-jira-config-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 18px 20px;
    border-left: 4px solid ${LG_COLOR};
  }

  .feedback-jira-config-header,
  .feedback-detail-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .feedback-jira-config-header .feedback-panel-title {
    margin-bottom: 0;
  }

  .feedback-jira-config-header .badge {
    padding: 7px 10px;
    border-radius: 999px;
    font-size: 0.76rem;
    font-weight: 700;
  }

  .feedback-jira-config-grid {
    display: grid;
    grid-template-columns: minmax(260px, 1.25fr) repeat(2, minmax(200px, 1fr));
    gap: 14px 16px;
    align-items: end;
  }

  .feedback-jira-config-grid .form-label {
    margin-bottom: 6px;
    color: ${GRAPHITE_COLOR};
    font-size: 0.82rem;
    font-weight: 700;
  }

  .feedback-jira-config-grid .form-control {
    min-height: 42px;
    border-radius: 12px;
    border-color: rgb(15 23 42 / 12%);
  }

  .feedback-jira-switch {
    min-height: 42px;
    display: flex;
    align-items: center;
    padding: 9px 12px;
    border-radius: 12px;
    background: ${ICE_COLOR};
    border: 1px solid #e3e7ec;
  }

  .feedback-jira-switch .form-check {
    margin: 0;
  }

  .feedback-jira-switch .form-check-label {
    color: ${GRAPHITE_COLOR};
    font-weight: 700;
  }

  .feedback-jira-config-footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto;
    align-items: center;
    gap: 12px;
    padding-top: 2px;
    color: #667085;
    font-size: 0.84rem;
  }

  .feedback-jira-config-footer .badge {
    justify-self: end;
    padding: 7px 10px;
    border-radius: 999px;
  }

  .feedback-jira-config-footer .btn {
    min-height: 38px;
    padding: 0 16px;
    border-radius: 8px;
    font-weight: 700;
    white-space: nowrap;
  }

  .feedback-metric-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    width: min(480px, 100%);
  }

  .feedback-metric-card,
  .feedback-panel {
    border: 1px solid #dde2e8;
    border-radius: 8px;
    background: ${WHITE_COLOR};
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .feedback-metric-card {
    padding: 14px 16px;
  }

  .feedback-metric-label {
    margin: 0 0 8px;
    color: ${GRAPHITE_COLOR};
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .feedback-metric-value {
    margin: 0;
    color: ${MAIN_BLUE_COLOR};
    font-size: 1.6rem;
    font-weight: 700;
  }

  .feedback-toolbar {
    background: ${WHITE_COLOR};
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 5px 16px rgba(65, 70, 80, 0.06);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 14px 18px;
  }

  .feedback-filter-group {
    display: inline-flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .feedback-admin-search {
    width: min(520px, 100%);
    max-width: 520px;
    min-height: 42px;
    border-radius: 12px;
    border-color: rgb(15 23 42 / 12%);
  }

  .feedback-grid {
    display: grid;
    grid-template-columns: minmax(0, 2.15fr) minmax(360px, 0.95fr);
    gap: 18px;
    align-items: start;
  }

  .feedback-panel {
    padding: 18px;
    min-height: 0;
    overflow: hidden;
  }

  .feedback-panel-title {
    margin: 0 0 14px;
    color: ${GRAPHITE_COLOR};
    font-size: 1rem;
    font-weight: 700;
  }

  .feedback-list-panel {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .feedback-detail-panel {
    min-width: 0;
    overflow: visible;
  }

  .feedback-table-wrap {
    display: flex;
    flex-direction: column;
    max-height: 560px;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid rgb(15 23 42 / 8%);
  }

  .feedback-record-list {
    overflow: auto;
    border-radius: 8px;
    border: 1px solid #e3e7ec;
    max-height: 620px;
  }

  .feedback-list-panel .feedback-table-wrap,
  .feedback-list-panel .feedback-record-list {
    flex: 1;
  }

  .feedback-record-list {
    background: #f8f9fb;
    display: grid;
    gap: 10px;
    padding: 12px;
  }

  .feedback-record-card {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(65, 70, 80, 0.05);
    color: ${GRAPHITE_COLOR};
    cursor: pointer;
    display: grid;
    gap: 9px;
    padding: 14px;
    text-align: left;
    transition:
      background 0.16s ease,
      border-color 0.16s ease,
      box-shadow 0.16s ease;
    width: 100%;
  }

  .feedback-record-card:hover {
    border-color: #c6ced8;
    box-shadow: 0 6px 16px rgba(65, 70, 80, 0.08);
  }

  .feedback-record-card.is-selected {
    background: #fff5f8;
    border-color: ${LG_COLOR};
    box-shadow:
      inset 3px 0 0 ${LG_COLOR},
      0 6px 16px rgba(165, 1, 53, 0.08);
  }

  .feedback-record-card-topline,
  .feedback-record-meta {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .feedback-record-date,
  .feedback-record-meta {
    color: #66707d;
    font-size: 0.8rem;
  }

  .feedback-record-date {
    margin-left: auto;
  }

  .feedback-record-title {
    color: ${GRAPHITE_COLOR};
    font-size: 0.98rem;
    font-weight: 700;
    line-height: 1.35;
  }

  .feedback-record-meta span:not(:last-child)::after {
    color: #aab3bf;
    content: '/';
    margin-left: 8px;
  }

  .feedback-table-wrap > .table-responsive {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
  }

  .feedback-table {
    margin: 0;
    min-width: 980px;
  }

  .feedback-table th,
  .feedback-table td {
    padding: 10px 12px;
    vertical-align: middle;
  }

  .feedback-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f3f5f8;
    color: ${GRAPHITE_COLOR};
    font-size: 0.78rem;
    font-weight: 700;
    border-bottom: 1px solid #d9dde3;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .feedback-table thead th:first-child,
  .feedback-table tbody td:first-child {
    min-width: 92px;
    white-space: nowrap;
  }

  .feedback-table tbody tr {
    cursor: pointer;
    transition: background 0.18s ease;
  }

  .feedback-table tbody tr:hover {
    background: #f8fafc;
  }

  .feedback-table tbody tr.is-selected {
    background: #fff5f8;
  }

  .feedback-summary-cell {
    min-width: 260px;
  }

  .feedback-status-column {
    width: 96px;
  }

  .feedback-issue-column {
    min-width: 260px;
  }

  .feedback-ticket-column,
  .feedback-linked-column {
    text-align: center;
    width: 120px;
  }

  .feedback-summary-title {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 0.9rem;
    font-weight: 700;
    line-height: 1.35;
  }

  .feedback-summary-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px 8px;
    margin: 4px 0 0;
    color: #667085;
    font-size: 0.78rem;
  }

  .feedback-summary-meta .badge {
    margin-right: 2px;
  }

  .feedback-ticket-id-cell,
  .feedback-linked-cell {
    text-align: center;
    white-space: nowrap;
  }

  .feedback-muted {
    color: #98a2b3;
    font-size: 0.84rem;
    font-weight: 700;
  }

  .feedback-jira-inline-link {
    color: ${LG_COLOR};
    font-weight: 700;
    white-space: nowrap;
  }

  .feedback-submitted-cell {
    min-width: 116px;
    color: #667085;
    font-size: 0.78rem;
    line-height: 1.35;
    white-space: nowrap;
  }

  .feedback-submitted-cell span {
    display: block;
  }

  .feedback-table-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border-top: 1px solid rgb(15 23 42 / 8%);
    background: ${WHITE_COLOR};
    color: #667085;
    font-size: 0.84rem;
  }

  .feedback-pagination-controls {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .feedback-pagination-controls .form-control {
    width: auto;
    min-width: 112px;
  }

  .feedback-detail-header {
    background: #f8f9fb;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 14px;
    padding: 16px;
  }

  .feedback-detail-actions {
    justify-content: flex-start;
  }

  .feedback-detail-actions .btn {
    min-height: 34px;
    padding: 0 12px;
    border-radius: 8px;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .feedback-detail-title {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 1.05rem;
    font-weight: 800;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .feedback-detail-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 12px;
    margin-bottom: 18px;
  }

  .feedback-meta-card {
    border-radius: 8px;
    border: 1px solid #e3e7ec;
    background: #f8fafc;
    padding: 12px 14px;
  }

  .feedback-meta-label {
    margin: 0 0 6px;
    color: #667085;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .feedback-meta-value {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 0.92rem;
    line-height: 1.5;
    word-break: break-word;
  }

  .feedback-meta-error {
    margin: 6px 0 0;
    color: ${LG_COLOR};
    font-size: 0.78rem;
    line-height: 1.45;
    word-break: break-word;
  }

  .feedback-meta-hint {
    margin: 6px 0 0;
    color: #667085;
    font-size: 0.78rem;
    line-height: 1.45;
    word-break: break-word;
  }

  .feedback-description {
    margin-bottom: 18px;
    padding: 14px 16px;
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #e3e7ec;
    color: ${GRAPHITE_COLOR};
    line-height: 1.6;
    min-height: 96px;
    white-space: pre-wrap;
  }

  .feedback-jira-admin-note {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 14px;
    border: 1px solid rgb(165 1 53 / 14%);
    background: #fff7f9;
  }

  .feedback-jira-admin-note .feedback-panel-title {
    margin-bottom: 6px;
  }

  .feedback-jira-admin-note p {
    margin: 0;
    color: #667085;
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .feedback-jira-admin-note .btn {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 0 14px;
    border-radius: 8px;
    font-size: 0.84rem;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
  }

  .feedback-jira-admin-note .btn span {
    white-space: nowrap;
  }

  .feedback-comments {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
    max-height: 260px;
    overflow-y: auto;
    padding-right: 4px;
  }

  .feedback-comment {
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid #e3e7ec;
    background: ${WHITE_COLOR};
  }

  .feedback-comment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
  }

  .feedback-comment-author {
    color: ${GRAPHITE_COLOR};
    font-size: 0.9rem;
    font-weight: 700;
  }

  .feedback-comment-time {
    color: #667085;
    font-size: 0.78rem;
  }

  .feedback-comment-message {
    margin: 0;
    color: ${GRAPHITE_COLOR};
    font-size: 0.92rem;
    line-height: 1.55;
    white-space: pre-wrap;
  }

  .feedback-empty-state {
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #667085;
    border: 1px dashed #cfd6df;
    border-radius: 8px;
    background: #fcfdff;
    padding: 24px;
  }

  .btn-primary {
    background-color: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #8d012d;
    border-color: #8d012d;
  }

  .form-control:focus,
  .form-select:focus {
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
  }

  @media (max-width: 1180px) {
    .feedback-grid {
      grid-template-columns: 1fr;
    }

    .feedback-list-panel {
      min-height: 0;
    }

    .feedback-record-list {
      max-height: 420px;
    }

    .feedback-jira-config-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .feedback-jira-config-footer {
      grid-template-columns: 1fr;
    }

    .feedback-jira-config-footer .badge {
      justify-self: start;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    .feedback-admin-header {
      padding: 18px;
    }

    .feedback-metric-grid,
    .feedback-jira-config-grid,
    .feedback-detail-meta {
      grid-template-columns: 1fr;
    }

    .feedback-jira-admin-note {
      align-items: flex-start;
      flex-direction: column;
    }

    .feedback-table-footer {
      align-items: flex-start;
      flex-direction: column;
    }
  }
`;
